import { on, select, selectAll, closest, removeClass, addClass, toggleClass } from 'modules/dom'

const body = document.body
const ACTIVATE_CLASS = 'slideout-activate'
const ACTIVATE_SUBMENU_CLASS = 'submenu-activate'
const ITEM_MENU_CHILD_SELECTOR = '.js-nav-menu-child'
const SUB_MENU_CHILD_SELECTOR = '.js-sub-menu-child'
const MENU_ITEM_BACK_SELECTOR = '.js-menu-item-back'

export default function(el) {
  const closeButton = select('.js-close-slideout', el)
  const browseButtons = selectAll('.menu-item-has-children > a', el)

  const subMenuChild = selectAll(SUB_MENU_CHILD_SELECTOR, el)
  if (subMenuChild.length > 0) {
    subMenuChild.map((item) => {
      const parentMenuItem = item.parentNode
      if (parentMenuItem) {
        const parentMenuLink = parentMenuItem.firstChild

        if (parentMenuLink) {
          const newItem = document.createElement('li')
          newItem.className = 'menu-item menu-item--sub-heading menu-item--header-primary'

          const newItemBack = document.createElement('a')
          newItemBack.className = 'menu-item__back js-menu-item-back'
          newItemBack.innerHTML = parentMenuLink.text
          newItemBack.href = parentMenuLink.href

          const spanItemArrow = document.createElement('span')
          spanItemArrow.className = 'menu-item__back-arrow'

          let svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svgElement.setAttribute('xmlns','http://www.w3.org/2000/svg')
          svgElement.setAttribute('width','24')
          svgElement.setAttribute('height','24')
          svgElement.setAttribute('fill','none')

          let pathElement = document.createElementNS("http://www.w3.org/2000/svg", 'path')
          pathElement.setAttribute('stroke','#199956')
          pathElement.setAttribute('d','m8.5 5 7 7-7 7')

          svgElement.append(pathElement)
          spanItemArrow.append(svgElement)
          newItemBack.append(spanItemArrow)

          const newItemSeeAll = document.createElement('a')
          newItemSeeAll.className = 'menu-item__see-all'
          newItemSeeAll.innerHTML = 'SEE ALL'
          newItemSeeAll.href = parentMenuLink.href

          newItem.append(newItemBack)
          newItem.append(newItemSeeAll)

          item.prepend(newItem)
        }
      }
    }, subMenuChild)
  }

  const hasSubMenuOpen = () => select('.menu-item--menu-child.submenu-activate >' + SUB_MENU_CHILD_SELECTOR, el)

  const onSubMenuToggle = () => {
    const subMenuOpen = hasSubMenuOpen()

    if (subMenuOpen) {
      addClass(ACTIVATE_SUBMENU_CLASS, el)
    } else {
      removeClass(ACTIVATE_SUBMENU_CLASS, el)
    }
  }

  const menuItemBacks = selectAll(MENU_ITEM_BACK_SELECTOR, el)
  if (menuItemBacks.length > 0) {
    menuItemBacks.map((menuItemBack) => {
      on('click', (e) => {
        e.preventDefault()
        const childItems = selectAll(ITEM_MENU_CHILD_SELECTOR, el)
        removeClass(ACTIVATE_SUBMENU_CLASS, childItems)
        removeClass(ACTIVATE_SUBMENU_CLASS, el)
      }, menuItemBack)
    }, menuItemBacks)
  }

  const deactivateSlideOut = () => removeClass(ACTIVATE_CLASS, body)

  if (closeButton) {
    on('click', deactivateSlideOut, closeButton)
  }
  if (browseButtons.length > 0) {
    browseButtons.map((browseButton) => {
      on('click', (e) => {
        e.preventDefault()
        const target = e.target
        toggleClass(ACTIVATE_SUBMENU_CLASS, target.parentNode)

        onSubMenuToggle()
      }, browseButton)
    }, browseButtons)
  }
}
